<template>
  <div class="col-xs-12">
    <div class="row row--margin-top">
      <div
        v-for="pkg in packages"
        :key="pkg.id"
        class="col-xs-6"
      >
        <package-detail :offer-package="pkg"/>
      </div>
    </div>
  </div>
</template>

<script>
import PackageDetail from './PackageDetail'

export default {
  name: 'YouMayAlsoLikePackageListing',
  components: {
    PackageDetail
  },
  props: {
    packages: { type: Array, default: null }
  }
}
</script>

<style style="scss" scoped>
</style>



// WEBPACK FOOTER //
// WebResources/vue/shared/components/catalog/YouMayAlsoLike/PackageListing.vue